import { render, staticRenderFns } from "./trait.vue?vue&type=template&id=216a2efc&scoped=true&"
import script from "./trait.vue?vue&type=script&lang=js&"
export * from "./trait.vue?vue&type=script&lang=js&"
import style0 from "./trait.vue?vue&type=style&index=0&id=216a2efc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216a2efc",
  null
  
)

export default component.exports